module.exports = __webpack_public_path__ + "img/3.b3e34a26.png";